export default __webpack_public_path__ + "static/media/contenu.190c4fa3.svg";